import React from 'react';

const ShowError = ({ errorsModal, type, message }) => {
    return (
        <span>
            {errorsModal && ( 
                (errorsModal.message) ? 
                    <span className="text-danger">
                        {errorsModal.message}
                    </span>
                : ''    
            )}
        </span>
    );
};

export default ShowError;
